<template>
  <div class="zj-navmenu">
    <div ref="container" class="zj-navmenu-container">
    <ul ref="ul" @mousewheel="onMouseWheel">
      <li
        :class="item.isActive ? 'is-active' : ''"
        v-for="item in menu.MenuInfos"
        :key="item.MenuId">
        <a :href="item.routerPath || item.MenuUrl" @click.prevent="handleSelect(item, $event)">{{item.MenuName}}</a>
      </li>
    </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZjNavMenu',
  props: {
    height: String
  },
  methods: {
    handleSelect(m) {
      this.dispatch('ZjApp', 'nav-click', [m.MenuId,[m.MenuId]])
    },
    onMouseWheel(e) {
      const firefox = navigator.userAgent.indexOf('Firefox') != -1;
      e = e||window.event;
      if(e.stopPropagation){
        e.stopPropagation();
      }else{
        e.cancelBubble=true;
      }
    
      if(e.preventDefault){
        e.preventDefault();
      }else{
        e.returnValue=false;
      }
    
      const delta = firefox ? e.detail : e.wheelDelta;
      const container = this.$refs.container;

      if(delta < 0){
        container.scrollLeft = container.scrollLeft + 60;
      }else{
        container.scrollLeft = container.scrollLeft - 60;
      }
    }
  }
}
</script>
